/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiRoomFromJSON, StreemApiRoomToJSON, StreemApiRoomParticipantFromJSON, StreemApiRoomParticipantToJSON, StreemApiUserFromJSON, StreemApiUserToJSON, } from './';
export function StreemApiEventsRoomParticipantUpdatedFromJSON(json) {
    return StreemApiEventsRoomParticipantUpdatedFromJSONTyped(json, false);
}
export function StreemApiEventsRoomParticipantUpdatedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'user': !exists(json, 'user') ? undefined : StreemApiUserFromJSON(json['user']),
        'room': !exists(json, 'room') ? undefined : StreemApiRoomFromJSON(json['room']),
        'previousParticipant': !exists(json, 'previous_participant') ? undefined : StreemApiRoomParticipantFromJSON(json['previous_participant']),
        'updatedParticipant': !exists(json, 'updated_participant') ? undefined : StreemApiRoomParticipantFromJSON(json['updated_participant']),
    };
}
export function StreemApiEventsRoomParticipantUpdatedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'user': StreemApiUserToJSON(value.user),
        'room': StreemApiRoomToJSON(value.room),
        'previous_participant': StreemApiRoomParticipantToJSON(value.previousParticipant),
        'updated_participant': StreemApiRoomParticipantToJSON(value.updatedParticipant),
    };
}
//# sourceMappingURL=StreemApiEventsRoomParticipantUpdated.js.map